<template>
  <a :href="url">
    <div class="row responsaveis_uc2" data-equalizer-watch="orgao">
          <div class="small-1 medium-3 large-3 columns">
            <div class="imagem_orgao">
              <span class="circulo2"
                    :style="{ backgroundImage: 'url('+imagem+')' }"></span>
            </div>
          </div>
          <div class="small-11 medium-9 large-9 columns">
          <div class="descricao_orgao">
            <h5 class="responsavel_nome">{{nome}}</h5>
            <h6 class="responsavel_cargo">{{cargo}}</h6>
            <div class="row pessoa_dados">
              <div class="small-2 medium-2 large-2 columns">
                <i class="ms-Icon ms-Icon--Education"
                   title="Education"
                   aria-hidden="true"
                   v-if="categoria.length > 0"></i>
              </div>
              <div class="small-10 medium-10 large-10 columns">
                <p>{{categoria}}</p>
              </div>
              <div class="small-2 medium-2 large-2 columns">
                <i class="ms-Icon ms-Icon--Mail"
                   title="Mail" aria-hidden="true"></i>
              </div>
              <div class="small-10 medium-10 large-10 columns">
                <p>{{email}}</p>
              </div>
            </div>
        </div>
      </div>
    </div>
  </a>
</template>

<script>
export default {
  name: "pessoaDep",
  props:["nome","cargo","imagem","url","categoria","email","color"],
}
</script>

<style scoped>
.responsaveis_uc2{
  display: flex;
  flex-direction: row;
  background-color: #f4f4f4;
  margin-left: 2px !important;
  margin-top: 6px;
  height: 165px;
}

.circulo2{
  display: block;
  border-radius: 50%;
  height: 80px;
  width: 80px;
  background: #b1b1b1;
  margin-top: 25px;
  margin-bottom: 25px;
  background-size: cover;
  background-position: center;
}

.descricao_orgao {
/*  display: flex;
  flex: 2;
  flex-direction: column;
  margin-right: 15px;
  padding-top: 30px;*/
}

.descricao_orgao p {
  margin-bottom: 0;

}

.responsavel_nome {
  color: #333333;
  line-height: 1.4;
  font-size: 17px;
  padding-top: 25px;
  font-family: 'Montserrat Semibold';
  margin-bottom: 0px;


}

.responsavel_cargo {
  font-family: 'PT Sans Bold Italic';
  color: #333333;
  font-size: 16px;
  border-bottom: 2px solid;
  border-color: v-bind('color');
  display: inline-block;
  margin-bottom: 15px;
  /*#4d5cc9*/
}

.descricao_orgao i {
  color: #2c2b2b;
}

.descricao_orgao i {
  font-family: "PT Sans";
  font-size: 15px;
  display: inline-block;
  align-items: center;
  margin-bottom: -5px;
}

.descricao_orgao i::before {
  font-size: 23px;
  font-family: FabricMDL2Icons;
  display: inline-block;
  align-items: center;
  padding-right: 7px;

}

.pessoa_dados p {
  font-family: "PT Sans";
  color: #1f1f1f;
  padding-top: 4px;
  margin-left: -13px;
}

.pessoa_dados .columns {
  margin-top: -8px;
}

.pessoa_dados {
  padding-bottom: 20px;
}


@media (max-width : 1600px){
  .responsavel_nome {
    font-size: 16px;
  }

  .pessoa_dados p {
    font-size: 14px;
    padding-top: 5px;
  }
}

@media (max-width : 1400px){
  .circulo2 {
    height: 70px;
    width: 70px;
  }

  .pessoa_dados p {
    padding-left: 5px;
  }


}




@media (max-width : 1280px){
  .imagem_orgao {
    display: none;
  }

  .responsavel_nome {
    margin-left: -65px;
  }

  .responsavel_cargo {
    margin-left: -65px;
  }

  .pessoa_dados {
    margin-left: -80px;
  }

  .pessoa_dados p {
    margin-left: 0px;
    padding-left: 0px;
  }
}


  @media (max-width : 1160px){

    .row.responsaveis_uc2 .large-3 {
      display: none;
    }

    .row.responsaveis_uc2 .large-9 {
      flex: 0 0 100%;
      max-width: 100%;
    }

    .responsavel_nome {
      margin-left: 0px;
    }

    .responsavel_cargo {
      margin-left: 0px;
    }

    .pessoa_dados {
      margin-left: 0px;
    }

    .pessoa_dados .columns {
      margin-left: -10px;
    }

  }

@media (max-width : 1024px){

  .pessoa_dados p {
    margin-left: -20px;
  }
}

@media (max-width : 864px){
  .pessoa_dados p {
    margin-left: 0px;
  }
}

@media (max-width : 639px) {
  .pessoa_dados p {
    margin-left: 0px;
    padding-top: 2px;
  }

  .imagem_orgao {
    display: flex;
  }

  .row.responsaveis_uc2 .large-3 {
    display: flex;
  }

  .row.responsaveis_uc2 .large-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }

  .circulo2 {
    margin-left: 5px;
  }

  .pessoa_dados h5 {
    margin-left: -10px;
  }

  .responsavel_nome {
    font-family: Montserrat Semibold;
    font-size: 15px;
    padding-top: 20px;
    line-height: 18px;
  }


  .descricao_orgao {
    margin-left: -10px;
  }

  .responsavel_cargo {
    font-size: 13px;
    margin-bottom: 10px;
  }

  .descricao_orgao i::before {
    font-size: 18px;
  }

  .responsaveis_uc2 {
    height: auto;
  }

  .row.responsaveis_uc2:first-of-type {
    margin-top: 5px;
  }

  .pessoa_dados {
    padding-bottom: 10px;
  }

  .circulo2 {
    display: none;
  }





}


</style>